// utils/toTitleCase.js

export default function toTitleCase(value) {
    if (typeof value !== 'string') return '';
    return value
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export function formatEnum(value) {
    if (!value) return '';
    return value
        .replace(/_/g, ' ')
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
